import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]

  connect() {
    document.body.style.overflow = "hidden"
  }

  close(event) {
    if (event.target === this.element.querySelector('[data-action="click->modal#close"]') || event.type === "keydown") {
      this.element.remove()
      document.body.style.overflow = ""
    }
  }

  disconnect() {
    document.body.style.overflow = ""
  }
}
